<div class="row">
  <div class="col-xl-1 col-lg-1 hidden-md"></div>
  <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">

    <div class="row">
        <div class="col-12">

            <h1>Privacy Policy</h1>
            <p>Welcome to Orange Cyberdefense&rsquo;s G<span style="text-decoration: line-through;">l</span>obal Portal privacy policy for its customers and their representatives and end-users.</p>
            <p>Orange Cyberdefense provides a range of support and managed security services, to safely enable its customers to meet their business objectives. In doing so, Orange Cyberdefense processes certain Customer Personal Data (as defined in section 1).</p>
            <p>Orange Cyberdefense is committed to protect Customer Personal Data in accordance with the EU General Data Protection Regulation (the &ldquo;<strong>GDPR</strong>&rdquo;) and the EU ePrivacy legislation.</p>
            <p>Orange Cyberdefense is made up of different legal entities in different countries. This privacy policy is issued on behalf of all the Orange Cyberdefense legal entities, i.e.:</p>
            <ul>
                <li>Orange Cyberdefense France SAS (France)</li>
                <li>Orange Cyberdefense Netherland B.V. (The Netherlands)</li>
                <li>Orange Cyberdefense Belgium NV (Belgium)</li>
                <li>Orange Cyberdefense UK Limited (United Kingdom)</li>
                <li>Orange Cyberdefense Sweden AB (Sweden)</li>
                <li>Orange Cyberdefense Denmark A/S (Denmark)</li>
                <li>Orange Cyberdefense Norway AS (Norway)</li>
                <li>Orange Cyberdefense Germany GmbH (Germany)</li>
                <li>Orange Cyberdefense South Africa (South Africa)</li>
            </ul>
            <p>This privacy policy describes how Orange Cyberdefense (&ldquo;us or &ldquo;we&rdquo;) collect and use the personal data which you provide us to use our Global Portal, portal.orangecyberdefense.com, and the data we process in our Global Portal for the various services and activities we offer.</p>
            <ol>
                <li>Definitions</li>
                <li>The scope of this privacy policy</li>
                <li>Who we are and our contact information?</li>
                <li>What Customer Personal Data may we collect?</li>
                <li>How do we use Customer Personal Data as Controller and Processor?</li>
                <li>To whom may we disclose Customer Personal Data?</li>
                <li>International Transfers of Customer Personal Data</li>
                <li>Our data security practices</li>
                <li>Our data retention policy</li>
                <li>Data subject&rsquo;s rights</li>
            </ol>

            <p></p>

            <p class="OCDHeading"><strong>1. Definitions</strong></p>
            <table class="table" style="width: 85%; margin-left: auto; margin-right: auto;">
                <tbody>
                    <tr>
                        <td style="width: 33%">
                            <p><strong>Controller</strong></p>
                        </td>
                        <td>
                            <p>has the meaning set out in the GDPR in short, it is the company that (alone or jointly with others) determines the purposes and means of the processing of Personal Data.</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p><strong>Customer</strong></p>
                        </td>
                        <td>
                            <p>a customer of Orange Cyberdefense who is a business, enterprise or other organization, to the exclusion of natural persons.</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p><strong>Customer Personal Data</strong></p>
                        </td>
                        <td>
                            <p>(a) Personal Data that we collect from Customer Representatives while using the Global Portal and for the purposes of use of such portal (&ldquo;<strong>Customer Representative Personal Data</strong>&rdquo;); and (b) Personal Data that relates to End Users provided to us by Customers or generated by us in connection with the services that we provide to Customers (&ldquo;<strong>End User Personal Data</strong>&rdquo;)</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p><strong>Customer Representative</strong></p>
                        </td>
                        <td>
                            <p>a natural person authorized to represent a Customer</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p><strong>End User</strong></p>
                        </td>
                        <td>
                            <p>the natural persons who are the users of the solutions that we implement for Customers, such as for example Customer employees or clients</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p><strong>Personal Data</strong></p>
                        </td>
                        <td>
                            <p>any information relating to an identified or identifiable natural person</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p><strong>Processor</strong></p>
                        </td>
                        <td>
                            <p>has the meaning set out in the GDPR; in short, it is the company that processes Personal Data on behalf of the Controller</p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p></p>

            <p>&nbsp;</p>
            <p class="OCDHeading"><strong>2. The scope of this privacy policy</strong></p>
            <p><strong>What information does this privacy policy relate to?</strong></p>
            <p>This privacy policy applies to Customer Personal Data that Orange Cyberdefense processes in connection with its relationship with its Customers while using our Global Portal. This privacy policy describes our general Personal Data protection framework for the Global Portal and does not change the content of any individual contract signed with our Customers.</p>

            <p></p>

            <p>&nbsp;</p>
            <p class="OCDHeading"><strong>3. Who we are and our contact information?</strong></p>
            <p><strong>Controller</strong></p>
            <p>An Orange Cyberdefense entity acts as a Controller in respect of all Customer Personal Data collected or processed by Orange Cyberdefense for its own purposes, independently of its Customer&rsquo;s requirements and for which the Orange Cyberdefense entity solely determines the means of the processing outside of the contractual documentation agreed with the Customer.</p>
            <p>The Orange Cyberdefense entity engaging with you is the Controller in respect of the Personal Data of Customers Representatives processed through our Global Portal <a href="https://portal.orangecyberdefense.com/">https://portal.orangecyberdefense.com</a>.</p>
            <p>For further details on our processing activities as Controller and the type of Personal Data processed, please see section 5.</p>

            <p><strong>Processor</strong></p>
            <p>The Orange Cyberdefense entity you contract with as a Customer acts as a Processor in respect of all Customer Personal Data collected or processed by Orange Cyberdefense in order to provide its services to the Customer, on its instructions, and not for any other purpose.</p>
            <p>Each Customer defines the purpose of the processing of the Customer Personal Data by specifying the services it procures from Orange Cyberdefense entities and its end-users to which the service must be provided. The means of the processing are described in the contractual documentation agreed by Customer and the Orange Cyberdefense entity.</p>
            <p>For further details on our processing activities and the type of Personal Data processed, please see section 5. </p>
            <p><strong>Data protection officer</strong></p>
            <p>We have appointed a data protection officer (DPO) per entity who is responsible for overseeing questions in relation to this privacy policy. For requests to exercise your rights, please refer to section 10.</p>

            <p>&nbsp;</p>
            <p class="OCDHeading"><strong>4. What Customer Personal Data may we collect?</strong></p>
            <p>We may collect, use, store and transfer different kinds of Customer Personal Data which we have categorised in the table below.</p>
            <table class="table" style="width: 85%; margin-left: auto; margin-right: auto;">
                <tbody>
                    <tr class="rowfiller">
                        <th style="width: 33%">
                            <p><strong>Category</strong></p>
                        </th>
                        <th>
                            <p><strong>Personal Data in category</strong></p>
                        </th>
                    </tr>
                    <tr>
                        <td>
                            <p><strong>Contact Data</strong></p>
                        </td>
                        <td>
                            <p>first name, last name, email address, and job role within the Customer.</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p><strong>Support Data</strong></p>
                        </td>
                        <td>
                            <p>Customer Representative or End User service ticket information</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p><strong>Identity Data</strong></p>
                        </td>
                        <td>
                            <p>first name, last name, username or similar identifier, password.</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p><strong>Location Data</strong></p>
                        </td>
                        <td>
                            <p>geographic location</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p><strong>Technical Data</strong></p>
                        </td>
                        <td>
                            <p>internet protocol (IP) address, login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system, and platform, as well as other technology on the devices natural persons use to access our portal or other technical data generated through the use of the service.</p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p>&nbsp;</p>
            <p class="OCDHeading"><strong>5. How do we use Customer Personal Data as Controller and Processor?</strong></p>
            <table class="table" style="width: 85%; margin-left: auto; margin-right: auto;">
                <tbody>
                    <tr class="rowfiller">
                        <th colspan="3">
                            <p><strong>Customer Personal Data for which we are Controller</strong></p>
                        </th>
                    </tr>
                    <tr>
                        <td style="width: 33%">
                            <p><strong>Our Activity</strong></p>
                        </td>
                        <td style="width: 33%">
                            <p><strong>Types of Personal Data processed</strong></p>
                        </td>
                        <td>
                            <p><strong>Our lawful basis for processing</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>To administer and protect our business and our portal</p>
                        </td>
                        <td>
                            <p>Contact Data</p>
                            <p>Technical Data</p>
                        </td>
                        <td>
                            <p>Necessary for our <strong>legitimate interests </strong>(for running our business, provision of administration, and IT services and network security)</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>To provide access to you, as an individual, to our portal as a Customer Representative</p>
                        </td>
                        <td>
                            <p>Identity Data</p>
                            <p>Contact Data</p>
                            <p>Technical Data</p>
                            <p>Location Data</p>
                            <p></p>
                        </td>
                        <td>
                            <p>Necessary for the <strong>legitimate interests </strong>of your organisation, our Customer, to provide you with this feature to facilitate your use of the service</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p></p>
            <p>The tables below show the ways that we use Customer Personal Data for which we are Controller and our legal basis for doing so (including a description of our legitimate interests), as well as the ways that we use Customer Personal Data for which we are Processor.</p>
            <p>Further information on Customer Personal Data which we process as Processor will be contained in the contractual documentation agreed with the Customer</p>
            <table class="table" style="width: 85%; margin-left: auto; margin-right: auto;">
                <tbody>
                    <tr class="rowfiller">
                        <td colspan="2">
                            <p><strong>Customer Personal Data for which we are Processor</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 66%">
                            <p><strong>Our Activity</strong></p>
                        </td>
                        <td>
                            <p><strong>Types of Personal Data processed</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Delivering, activating and implementing services and changes to services requested by Customer (including managed security services ordered by Customer)</p>
                        </td>
                        <td>
                            <p>Identity Data</p>
                            <p>Contact Data</p>
                            <p>Support Data</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Incident management (troubleshooting, resolution and reporting) related to a specific Customer</p>
                        </td>
                        <td>
                            <p>Identity Data</p>
                            <p>Contact Data</p>
                            <p>Support Data</p>
                            <p>Technical Data</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Providing reports to Customer on services and other reports required by the Customer</p>
                        </td>
                        <td>
                            <p>Identity Data</p>
                            <p>Contact Data</p>
                            <p>Support Data</p>
                            <p>Technical Data</p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p>&nbsp;</p>

            <p class="OCDHeading"><strong>6. To whom may we disclose Customer Personal Data?</strong></p>

            <p><strong>As a Controller of the Customer Personal Data</strong></p>
            <p>We may share Customer Personal Data in our capacity as Controller of such data with the parties set out below (External parties) for the purposes set out in the table in section 5 above.</p>
            <p><strong>Orange Cyberdefense entities</strong></p>
            <p>The Orange Cyberdefense entity which is the Controller of your Personal Data may share such Data with other Orange Cyberdefense entities acting as Processors.</p>
            <p><strong>External parties</strong></p>
            <p>Service providers acting as Processors, such as providers of IT and system administration services, maintenance, expert technical support, or hosting.</p>
            <table class="table" style="width: 85%; margin-left: auto; margin-right: auto;">
                <tbody>
                    <tr class="rowfiller">
                        <td style="width: 25%">
                            <p><strong>Party</strong></p>
                        </td>
                        <td>
                            <p><strong>Description</strong></p>
                        </td>
                        <td style="width: 25%">
                            <p><strong>Location</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Google, Inc</p>
                        </td>
                        <td>
                            <p>Google Cloud Platform to host the Portal Infrastructure including:</p>
                            <p>&middot; TLS services</p>
                            <p>&middot; Network Segregation</p>
                            <p>&middot; Application Firewall</p>
                            <p>&middot; Load Balancing</p>
                        </td>
                        <td width="141">
                            <p>Belgium</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Okta, Inc</p>
                        </td>
                        <td>
                            <p>Identity &amp; Access Solution which provides access to the portal</p>
                        </td>
                        <td width="141">
                            <p>Ireland</p>
                            <p>Germany</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Salesforce</p>
                        </td>
                        <td>
                            <p>IT Service Management system used for contract entitlement management, the creation of support tickets &amp; cases as well as ongoing management of such tickets &amp; cases</p>
                        </td>
                        <td width="141">
                            <p>Netherlands</p>
                            <p>France</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>ServiceNow</p>
                        </td>
                        <td>
                            <p>IT Service Management system used for contract entitlement management, the creation of support tickets &amp; cases as well as ongoing management of such tickets &amp; cases</p>
                        </td>
                        <td width="141">
                            <p>Ireland</p>
                            <p>Netherlands</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p><strong>As a Processor of the Customer Personal Data</strong></p>
            <p>We disclose Customer Personal Data to other Processors, whether other entities within Orange Cyberdefense or external providers, that we engage in our capacity as Processor for carrying out specific processing activities on behalf of our Customer, who is considered as the Controller.</p>
            <p>We inform our Customers of all the Processors, other entities within Orange Cyberdefense and, external providers or partners, we engage under a <u>general written authorization</u> (or specific authorization).</p>

            <p>&nbsp;</p>

            <p class="OCDHeading"><strong>7. International Transfers of Customer Personal Data</strong></p>

            <p>We may transfer and process Customer Personal Data to/in countries other than the country in which the Customer Personal Data is initially collected.</p>
            <p><strong>International transfers to Cyberdefense entities</strong></p>
            <p>We may transfer Customer Personal Data amongst Orange Cyberdefense entities as Controller or Processor, inside or outside of the European Union (&ldquo;EU&rdquo;).</p>
            <p>All Orange Cyberdefense entities have signed an intra-group agreement for processing and transferring personal data, which includes the EU Commission standard contractual clauses. This intra-group agreement defines the adequate safeguards all Orange Cyberdefense entities must put in place to protect Personal Data and its transfer. For more information about the transfer of Customer Personal Data to Orange Cyberdefense entities for a specific processing activity, please contact us.</p>
            <p><strong>International transfers to external suppliers</strong></p>
            <p>When we transfer Customer Personal Data to an external supplier in another country, we make sure that a similar degree of protection is afforded to the Customer Personal Data. For transfers outside of the EU or to a country which the EU Commission has not assessed as providing an adequate level of protection (for further details, see the relevant page of the European Commission website), we use the EU Commission standard contractual clauses or another appropriate safeguard.</p>

            <p>&nbsp;</p>

            <p class="OCDHeading"><strong>8. Our data security practices</strong></p>

            <p>We have put in place appropriate security measures to prevent Customer Personal Data from being accidentally lost, used, or accessed in an unauthorised way, altered or disclosed. In addition, we limit access to Customer Personal Data to those employees who have a business need to access it. They will only process Customer Personal Data on our instructions, and they are subject to a duty of confidentiality.</p>
            <p>We have taken steps to encrypt all data that is stored in the Global Portal database. Customer Personal Data which is processed by us as a Processor is <u>not stored</u> in the Global Portal, it is retrieved from our IT Service Management systems on request via actions in the Global Portal.</p>
            <p>We have implemented security technologies and put in place procedures to deal with any suspected Personal Data breach and will notify Customers and any applicable regulator of a breach where we are legally or contractually required to do so.</p>

            <p>&nbsp;</p>

            <p class="OCDHeading"><strong>9. Our data retention policy</strong></p>

            <p>How long will we retain Customer Personal Data?</p>
            <p>We retain Customer Personal Data in respect of which we are Processor for the period agreed with our Customer, who is considered as the Controller. We may retain Customer Personal Data for a longer period in the event of a complaint or if we reasonably believe there is a prospect of litigation in respect to our relationship with our Customers. Our contractual documentation agreed with our Customer describes the retention periods for the processing activities we perform as Processor for our Customer, the Controller.</p>
            <p>We retain Customer Personal Data in respect of which we are Controller only for as long as reasonably necessary to fulfil the purposes we collected it for, such as for as long as access to our Global Portal is required.</p>

            <p>&nbsp;</p>

            <p class="OCDHeading"><strong>10. Data subjects rights</strong></p>

            <p><strong>What are the rights?</strong></p>
            <p>Under certain circumstances, individual Customer Representatives or End Users may have the following rights under data protection laws in relation to their Personal Data:</p>
            <ul>
                <li>request access to, correction of, or erasure of Personal Data</li>
                <li>object to processing of Personal Data</li>
                <li>request restriction of processing of Personal Data</li>
                <li>make a complaint to the relevant national data protection regulator</li>
            </ul>
            <p><strong>Whom should you contact?</strong></p>
            <ol>
                <li>If you want to exercise your rights in respect of your Personal Data of which Orange Cyberdefense is a Controller, contact us by email at <a href="mailto:privacy@orangecyberdefense.com">privacy@orangecyberdefense.com</a></li>
                <li>If you want to exercise your rights in respect of your Personal Data of which Orange Cyberdefense is a Processor for a Customer:</li>
            </ol>
            <p>You should contact your employer, or the organisation through which you have been using Orange Cyberdefense&rsquo;s services in the first instance, to obtain information about, or exercise, the rights you may have in respect of Personal Data. The person(s) authorised by your organisation to ask our assistance in respect of your request will contact us.</p>
            <p><strong>Data Protection Officer Contacts</strong></p>
            <p>Please email <a href="mailto:privacy@orangecyberdefense.com">privacy@orangecyberdefense.com</a> to make contact with a data protection officer.</p>
            <ol start="3">
                <li>If you are authorised by our Customer to ask Orange Cyberdefense to help in answering a data subject request, you need to contact us using the email address <a href="mailto:privacy@orangecyberdefense.com">privacy@orangecyberdefense.com</a></li>
            </ol>
            <p></p>
            <p><strong>How will Orange Cyberdefense deal with my request?</strong></p>
            <p><em>Usually no fee</em></p>
            <p>You will not have to pay a fee to access your Personal Data (or to exercise any of your other rights). However, we may charge a reasonable fee if your request is clearly unfounded, repetitive or excessive. Alternatively, we could refuse to comply with your request in these circumstances.</p>
            <p><em>What we require</em></p>
            <p>We may need to request specific information from you to help us confirm your identity and ensure your right to access your Personal Data (or to exercise any of your other rights). This is a security measure to ensure that Personal Data is not disclosed to any person who has no right to receive it. We may also contact you to ask you for further information in relation to your request to speed up our response.</p>
            <p><em>When we will respond</em></p>
            <p>We try to respond to all legitimate requests within one month. Occasionally it could take us longer than a month if your request is particularly complex or you have made a number of requests. In this case, we will notify you and keep you updated.</p>
            <p></p>
            <p>Dated: 4<sup>th</sup> April 2022</p>
            <p></p>
            <br /><br /><br /><br /><br />
        </div>
    </div>

  </div>
</div>